import { Pencil } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { PROFILE_LAYOUT_STRINGS as S } from '@/lib/constants/profile-layout-strings';

export interface SectionEditButtonProps {
  /** Section name, used for the accessible label ("Edit Financials"). */
  section: string;
  onClick: () => void;
}

/** The pencil "Edit" action on a profile section card's header (FR-166). */
export function SectionEditButton({ section, onClick }: SectionEditButtonProps) {
  return (
    <Button
      variant="outline-sm"
      onClick={onClick}
      aria-label={S.EDIT_SECTION_LABEL(section)}
      className="inline-flex shrink-0 items-center gap-1.5"
    >
      <Pencil size={14} aria-hidden />
      {S.EDIT}
    </Button>
  );
}
